import { render } from "./about.vue?vue&type=template&id=18e3adac&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=18e3adac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18e3adac"

export default script